export default () => {
	const header = document.querySelector('.hd-Header');
	const triggers = document.querySelectorAll('.js-menu-item');
	const dropDown = document.querySelector('.hd-Banner_Dropdown');
	const menus = [...document.querySelectorAll('.js-submenu')];

	let isOpen = false;
	let delay = null;

	const observer = new MutationObserver((ml) => {
		if (header.classList.contains('hd-Header--hidden')) {
			closeMenu();
		}
	});

	observer.observe(header, {
		attributeFilter: ['class'],
	});

	function openMenu(trigger) {
		if (delay) {
			window.clearTimeout(delay);
		}

		if (!isOpen) {
			dropDown.setAttribute('aria-expanded', true);
			header.setAttribute('data-menu-active', true);
			document.body.classList.add('freeze-viewport');
			isOpen = true;
			emit('nav-open');
		}
	}

	function clearActive() {
		triggers.forEach(trigger => {
			trigger.removeAttribute('data-menu-active');
		});

		menus.forEach((menu) => {
			menu.setAttribute('aria-expanded', false);
		});
	}

	function closeMenu() {
		if (isOpen) {
			delay = window.setTimeout(() => {
				dropDown.setAttribute('aria-expanded', false);
				menus.forEach((menu) => {
					menu.setAttribute('aria-expanded', false);
				});
				header.removeAttribute('data-menu-active');
				clearActive();
				document.body.classList.remove('freeze-viewport');
				isOpen = false;
			}, 300);
		}
	}

	function open(name, trigger) {
		if (!name) {
			closeMenu();
			return;
		}

		openMenu(trigger);
		clearActive();

		trigger.setAttribute('data-menu-active', true);

		menus.find((menu) => menu.dataset.submenu === name)?.setAttribute('aria-expanded', true);
	}

	function emit(state) {
		let newEvent = new Event(state);
		document.dispatchEvent(newEvent);
	}

	document.addEventListener('close-navigation', () => {
		closeMenu();
	});

	dropDown.addEventListener('mouseenter', () => {
		if (delay) {
			window.clearTimeout(delay);
		}
	});

	dropDown.addEventListener('mouseleave', () => {
		closeMenu();
	});

	triggers.forEach((trigger) => {
		trigger.addEventListener('mouseenter', () => {
			open(trigger.dataset.submenuTarget, trigger);
		});

		trigger.addEventListener('focus', () => {
			open(trigger.dataset.submenuTarget, trigger);
		});

		trigger.addEventListener('mouseleave', () => {
			closeMenu();
		});

		trigger.addEventListener('blur', () => {
			closeMenu();
		});
	});
}
